import { flow, Instance, types } from "mobx-state-tree";
import { currentUserStoreGetter, servicesGetters } from "../utils";
import { IRole, Role } from "./Role";
import { Role as OrgRole, AppPermission } from "@closerplatform/spinner-openapi";
import { logger } from "@fidget/common/utils";

export const RoleStore = types
  .model("RoleStore", {
    roles: types.map(Role)
  })
  .views(servicesGetters)
  .views(currentUserStoreGetter)
  .views((self) => {
    const views = {
      get rolesArray(): IRole[] {
        return [...self.roles.values()];
      }
    };

    return views;
  })
  .actions((self) => {
    const actions = {
      getRoleById(id: string): IRole | undefined {
        return self.roles.get(id);
      },

      setRoles: flow(function* setRoles(roles: OrgRole[]) {
        self.roles.clear();
        roles
          .map((role) => {
            const { permissions, ...rest } = role;

            const parsedPermissions = permissions
              ?.filter((p) => Object.values(AppPermission).includes(p))
              .map((perm) => perm);

            return Role.create({ ...rest, permissions: parsedPermissions });
          })
          .forEach((role) => self.roles.put(role));
      })
    };

    return actions;
  })
  .actions((self) => ({
    loadRoles: flow(function* loadRoles() {
      try {
        const roles: OrgRole[] = yield self.spinnerService.getOrgRoles();
        yield self.setRoles(roles);
      } catch (err) {
        logger.error({ message: "Couldn't load org roles", error: err });
      }
    }),

    updateRole({ id, orgId, permissions, name }: OrgRole) {
      self.roles.put({ id, orgId, permissions, name });
    }
  }));

export interface IRoleStore extends Instance<typeof RoleStore> {}
